import { render, staticRenderFns } from "./CommonQuestion.vue?vue&type=template&id=535779c1&scoped=true&"
import script from "./CommonQuestion.vue?vue&type=script&lang=ts&"
export * from "./CommonQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./CommonQuestion.vue?vue&type=style&index=0&id=535779c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535779c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
